import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-f_3",
  "use": "icon-f_3-usage",
  "viewBox": "0 0 15.351 16.031",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.351 16.031\" id=\"icon-f_3\"><defs><style>#icon-f_3 .a{fill:#8c8c8c;}</style></defs><g transform=\"translate(-1299.19 -185.182)\"><path class=\"a\" d=\"M100.721,140.352l-3.679,3.679-3.679-3.679h2.944v-8.831h1.472v8.831h2.944Z\" transform=\"translate(1213.82 57.182)\" /><path class=\"a\" d=\"M92.692,131.679H89.749v8.831H88.277v-8.831H85.333L89.013,128l3.679,3.679Z\" transform=\"translate(1213.856 57.182)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol